import { faAndroid, faApple, faWindows } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Divider from '../../Components/DividerSite/Divider'
import TopNavbar from '../../Components/Navbar/TopNavbar'
import Style from './Guide.module.css'
const Guide = () => {
    return (
        <div className='pageHolder'>
            <TopNavbar/>
            <section className={Style.LandingGuid}>
                <img className={Style.ImageHolder} src='/Assets/Images/Regular/guid.jpg' alt='fixboard'/>
                <div className={Style.AppHolder}>
                    <p>برای دانلود نرم افزار روی سیستم عامل خود کلیک کنید:</p>
                    <section className={Style.AppPart}>
                        <a href='https://dl.spotplayer.ir/assets/bin/spotplayer-22.exe' className={Style.App}>
                            <FontAwesomeIcon icon={faWindows}/>
                            <h3>Windows</h3>
                        </a>
                        <a href='https://dl.spotplayer.ir/assets/bin/spotplayer-22.apk' className={Style.App}>
                            <FontAwesomeIcon icon={faAndroid}/>
                            <h3>Android</h3>
                        </a>
                        <a href='https://dl.spotplayer.ir/assets/bin/spotplayer-22.dmg' className={Style.App}>
                            <FontAwesomeIcon icon={faApple}/>
                            <h3>mac</h3>
                        </a>
                    </section>
                </div>
            </section>
            <Divider title={'راهنمای نرم افزار'}/>
            <section className='pageHolder'>
                <div className={Style.TeachPart}>
                    <div><p>1</p>لایسنس دریافتی از سایت را در مکان مشخص شده وارد کنید</div>
                    <img src="/Assets/Images/Teach/Image 7.png" alt="spotPlayer" />
                </div>
                <div className={Style.TeachPart}>
                    <div><p>2</p>دوره ها در این قسمت نمایش داده می شود</div>
                    <img src="/Assets/Images/Teach/Image 8.png" alt="spotPlayer" />
                </div>
            </section>
        </div>
    )
}

export default Guide
